import axiosInstance from "@/api/axios-instance";

export async function updateCouplesPackUsers({
  user_ids,
  couples_pack_usage_identifier
}: {
  user_ids: string[]
  couples_pack_usage_identifier: string;
}) {
  const response = await axiosInstance.put(`/couples-packs/update-users`, {
    user_ids,
    couples_pack_usage_identifier,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update users");
  }

  return response.data;
}